import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow41_6Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow41_6 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("LOSSES_41_6") || "Losses for everything in this category"}
        subDescription={t("LOSSES_41_6_DESC") || "This is where you record any losses in this category relating to water, packaging and product components. In the 'Product and Manufacturing' section, you could record, for example, that you glue something and some of the weight is lost due to off-gassing during the drying phase. Losses during transport can be also recorded here."}
        isNormal={true}
        number={"41.6"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-41-6-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow41_6Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow41_6;


